var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.getHeaders,"items":_vm.listadoAnticipos},scopedSlots:_vm._u([{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$moment(item.fecha).format('DD/MM/YYYY'))+"\n  ")]}},{key:"item.porcentaje",fn:function(ref){
var item = ref.item;
return [_c('v-chip',[_vm._v(" "+_vm._s(item.porcentaje)+"% ")])]}},{key:"item.importe",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("currency")(item.importe))+"\n  ")]}},{key:"item.importeInicioTrabajos",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("currency")(item.importeInicioTrabajos))+"\n  ")]}},{key:"item.importeCostoFinanciamiento",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("currency")(item.importeCostoFinanciamiento))+"\n  ")]}},{key:"item.iva",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("currency")(item.iva))+"\n  ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("currency")(item.total))+"\n  ")]}},{key:"item.solicitudPago",fn:function(ref){
var item = ref.item;
return [_c('estatus-pago',{attrs:{"solicitud":item.solicitudPago}})]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":item.createdAt}})]}},(!_vm.soloLectura)?{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [(_vm.mixValidaScopesActions(2))?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.editar(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v("Editar")])]):_vm._e(),(_vm.mixValidaScopesActions(3))?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.borrar(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}],null,true)},[_c('span',[_vm._v("Borrar")])]):_vm._e()]}}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }